import ContentSave from '@mui/icons-material/Save';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
} from '@mui/material';
import { FormEvent, useEffect, useState } from 'react';
import { Toolbar } from 'react-admin';
import { DialogCloseButton } from '../misc/DialogCloseButton';
import { ScmTag } from '../types';
import { colors } from '../misc/colors';
import { RoundButton } from '../misc/RoundButton';

type TagDialogProps = {
    open: boolean;
    tag?: Pick<ScmTag, 'descricao_tag' | 'color'>;
    title: string;
    onSubmit(tag: Pick<ScmTag, 'descricao_tag' | 'color' | 'visibilidade'>): Promise<void>;
    onClose(): void;
};

export function TagDialog({
    open,
    tag,
    title,
    onClose,
    onSubmit,
}: TagDialogProps) {
    const [newTagName, setNewTagName] = useState('');
    const [newTagColor, setNewTagColor] = useState(colors[0]);
    const [disabled, setDisabled] = useState(false);

    const handleNewTagNameChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setNewTagName(event.target.value);
    };

    const handleClose = () => {
        setDisabled(false);
        onClose();
    };

    const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        var novaVis = { compra: false, fornecedor: (title == "fornecedor"), ordemcompra: (title == "ordemcompra") };
        await onSubmit({ descricao_tag: newTagName, color: newTagColor, visibilidade: novaVis });

        setDisabled(true);
        setNewTagName('');
        setNewTagColor(colors[0]);

        handleClose();
    };

    useEffect(() => {
        setNewTagName(tag?.descricao_tag ?? '');
        setNewTagColor(tag?.color ?? colors[0]);
    }, [tag]);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
        >
            <form onSubmit={handleSubmit}>
                <DialogCloseButton onClose={handleClose} />
                <DialogTitle id="form-dialog-title">{title}</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        label="Nome da Tag"
                        value={newTagName}
                        onChange={handleNewTagNameChange}
                        sx={{ mt: 1 }}
                    />
                    <Box display="flex" flexWrap="wrap" width={230} mt={2}>
                        {colors.map(color => (
                            <RoundButton
                                key={color}
                                color={color}
                                selected={color === newTagColor}
                                handleClick={() => {
                                    setNewTagColor(color);
                                }}
                            />
                        ))}
                    </Box>
                </DialogContent>
                <DialogActions
                    sx={{
                        justifyContent: 'flex-start',
                        p: 0,
                    }}
                >
                    <Toolbar
                        sx={{
                            width: '100%',
                        }}
                    >
                        <Button
                            type="submit"
                            color="primary"
                            disabled={disabled}
                            variant="contained"
                            startIcon={<ContentSave />}
                        >
                            Salvar
                        </Button>
                    </Toolbar>
                </DialogActions>
            </form>
        </Dialog>
    );
}
